import React, { Component } from 'react';
import { connect } from 'react-redux';
import ListingsView from './Listings.view';

export class ListingsContainer extends Component {

  constructor(props){
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
  }

  componentDidMount() {
    this.getListings(this.props);
  }

  componentWillReceiveProps(nextProps){
    if(
      this.props.filtersFormState !== nextProps.filtersFormState ||
      this.props.page !== nextProps.page
    ){
      this.getListings(nextProps);
    }
  }

  getListings(props){
    const { dispatch, filtersFormState, page } = props;
    dispatch({
      type: 'FETCH_LISTINGS',
      payload: {
        filters: filtersFormState.data,
        page: page,
      }
    });
  }

  nextPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'LISTINGS_NEXT_PAGE',
    });
  }

  previousPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'LISTINGS_PREVIOUS_PAGE',
    });
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'LISTINGS_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  render() {
    return (<ListingsView
      onFilterChange={this.onFilterChange}
      nextPage={this.nextPage}
      previousPage={this.previousPage}
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { listings } = state;
  return {
    listings: listings.listings,
    filtersFormState: listings.filtersFormState,
    page: listings.page,
  };
}

export default connect(mapStateToProps)(ListingsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/Listings.container.js